import { render, staticRenderFns } from "./bindWeChat.vue?vue&type=template&id=2842dc0f&scoped=true&"
import script from "./bindWeChat.vue?vue&type=script&lang=js&"
export * from "./bindWeChat.vue?vue&type=script&lang=js&"
import style0 from "./bindWeChat.vue?vue&type=style&index=0&id=2842dc0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842dc0f",
  null
  
)

export default component.exports